var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 14.4062H1.75C0.98125 14.4062 0.34375 13.7687 0.34375 13C0.34375 12.2312 0.98125 11.5938 1.75 11.5938H24.25C25.0187 11.5938 25.6562 12.2312 25.6562 13C25.6562 13.7687 25.0187 14.4062 24.25 14.4062Z",
    fill: "#F57E2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.6562C12.2312 25.6562 11.5938 25.0187 11.5938 24.25V1.75C11.5938 0.98125 12.2312 0.34375 13 0.34375C13.7687 0.34375 14.4062 0.98125 14.4062 1.75V24.25C14.4062 25.0187 13.7687 25.6562 13 25.6562Z",
    fill: "#F57E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.e818f6f01121fa51bd841330ed8f4622.svg";
export { ForwardRef as ReactComponent };